import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { getRequirementById } from 'services/checklistEndPoints';
import { IRequirement } from 'interfaces/requirements.interface';

export const fetchRequirementById = createAsyncThunk(
  'requirement/fetchById',
  async (id: string) => {
    try {
      const endpoint = getRequirementById(id);
      const resp = await apiFetch<IRequirement>(endpoint).then((res) => res?.data || null);
      return resp;
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      throw Error(message);
    }
  }
);
